import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Config } from '../../Utils/Config';

const SubscriptionFooter = () => {
  return (
    <div className="subscription-footer text-center">
        <a href={Config.ListRVSignInUrl+"/"}>Home</a>
        <Link to={"/market-data"}>Market Data</Link>
        <a href={Config.ListRVSignInUrl+"/listings"}>Listings</a>
        <a href={Config.ListRVSignInUrl+"/vendors"}>Vendors</a>
        <a href={Config.ListRVSignInUrl+"/industry-insights"}>Industry Insights</a>
        <a href={Config.ListRVSignInUrl+"/user/addproperty"}>Submit Property</a>
        <a href={Config.ListRVSignInUrl+"/aboutus"}>About Us</a>
    </div>
  )
}
export default SubscriptionFooter;